import React from 'react';

// material-ui
import { Box, Button } from '@mui/material';

export default function TabButtons({ tabList, currentTab, setCurrentTabs }) {
    return (
        <Box
            sx={{
                display: "flex",
                gap: 1,
                overflowX: "auto",
                whiteSpace: "nowrap",
                py: 1,
                WebkitOverflowScrolling: "touch",
            }}
        >
            {tabList.map(({ key, label }) => {
                const active = currentTab === key;

                return (
                    <Button
                        key={key}
                        onClick={() => setCurrentTabs(key)}
                        variant={active ? "contained" : "outlined"}
                        disableElevation
                        sx={{
                            flex: "0 0 auto",
                            textTransform: "none",
                            borderTopLeftRadius: 8,
                            borderTopRightRadius: 8,
                            borderBottomLeftRadius: 8,
                            borderBottomRightRadius: 8,

                            bgcolor: active ? "rgb(2, 85, 151)" : "transparent",
                            color: active ? "white" : "text.secondary",
                            borderColor: "divider",
                            "&:hover": {
                                bgcolor: active ? "rgb(2, 85, 151)" : "action.hover",
                            },
                        }}
                    >
                        {label}
                    </Button>
                );
            })}
        </Box>
    );
}